// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module__container___2LaXf","switch":"index-module__switch___18xck","active":"index-module__active___2z6t-"};